// SYM-6267 / SYM-6234. An object panel is only shown while an object is
// selected; without one the panel's fields have nothing to read and crash.
export const panelToShow = <T>(tab: T | undefined, object: unknown) =>
  object ? tab : undefined;

// The alpha part of an `rgb(r,g,b,a)` fill, NaN when there is none.
export const fillAlpha = (fill: unknown) =>
  parseFloat(((fill as string) ?? '').split(',')[3] ?? '');
